export default "__VITE_ASSET__C91AQ31R__"